/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

// GET https://privacy.porsche-preview.com/static/consent-webcomponent/assets/i18n/de_DE_generic.json
export const translations = {
  consentWebcomponent: {
    actions: {
      acceptAll: 'Alle akzeptieren',
      close: 'Schließen',
      moreInfo: 'Mehr Informationen',
      saveSelection: 'Auswahl speichern',
      skip: 'Überspringen',
    },
    description:
      'Helfen Sie uns, Ihre Wünsche und Bedürfnisse noch besser zu verstehen. Mit Ihrer Einwilligung unterstützen Sie unsere Produktentwicklung und bleiben immer auf dem neuesten Stand.',
    headline: 'Werden Sie Teil der Faszination Porsche',
    modal: {
      ariaLabel: 'Details zur Einwilligung',
    },
    notifications: {
      errorHeadline: 'Der Inhalt ist derzeit nicht verfügbar.',
      errorLoadingConsents: 'Sie können dennoch mit dem nächsten Schritt fortfahren.',
    },
  },
}

// GET https://api.ppc.porsche-preview.com/user/api/v2/de/de_DE/user-consent
export const usercconsents = [
  {
    explicitChannels: [],
    implicitChannels: [],
    consentId: 'DEPPO01PAG',
    purpose: 'ProductOptimization',
    legalEntities: ['PSMGmbH', 'PorscheAG'],
    dataScopes: [
      'Fahrzeughistorie',
      'Daten zur Reparatur',
      'Wartungsdaten',
      'Transaktionsdaten',
      'Nutzungsdaten',
      'Verkehrsdaten',
      'Umweltdaten',
      'Zustandsdaten',
      'Verbindungsdaten',
      'Basisdaten',
      'Bewegungsdaten',
      'Analysedaten',
      'Betriebsdaten',
      'Standortbezogene Verkehrsdaten',
      'Standortdaten',
      'Standortbezogene Umweltdaten',
      'Kennungsdaten',
      'Identifikationsdaten',
      'Bilddaten aus Außenbildkameras',
    ],
    contentfulReference:
      'https://cdn.contentful.com/spaces/8lfo1rr5gpr0/environments/master/entries?content_type=consentsShort&fields.consentId=DEPPO01PAG&fields.language=de_DE&fields.revision=0',
    country: 'DE',
    language: 'de_DE',
    revision: 0,
    validFrom: '2019-01-25T11:55:33.815Z',
    isAccepted: false,
    content: {
      headline: 'Einwilligung zur Produktverbesserung',
      consentTextShort:
        'Durch die Weitergabe personenbezogener Daten unterstützen Sie unsere Produktentwicklung und verbessern Sie unsere Produkte und Dienstleistungen.',
      text: 'Ich willige ein, dass die Dr. Ing. h.c. F. Porsche AG und die Porsche Sales & Marketplace GmbH auf Fahrzeug-, Dienst- und Produktdaten zugreifen und zur Produktverbesserung (Entwicklung/Verbesserung von Produkten und Dienstleistungen, Fehleranalyse und Störungsbehebung, Produkt-Monitoring) verarbeiten. \n\nDie freiwillige Einwilligung kann jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen werden. Weitere Informationen sind in unseren Datenschutzhinweisen verfügbar.',
      legalParagraph:
        'Ich willige ein, dass die Dr. Ing. h.c. F. Porsche AG und die Porsche Sales & Marketplace GmbH auf Fahrzeug-, Dienst- und Produktdaten zugreifen und zur Produktverbesserung (Entwicklung/Verbesserung von Produkten und Dienstleistungen, Fehleranalyse und Störungsbehebung, Produkt-Monitoring) verarbeiten.\n\nDiese Einwilligung betrifft sowohl die Verarbeitung personenbezogener Daten als auch die Speicherung von und den Zugriff auf Informationen in der Endeinrichtung (bspw. dem Fahrzeug).',
      consentTextExtended: {
        content: [],
      },
      channels: [],
      consentExtendedList: [
        'Fahrzeughistorie',
        'Daten zur Reparatur',
        'Wartungsdaten',
        'Transaktionsdaten',
        'Nutzungsdaten',
        'Verkehrsdaten',
        'Umweltdaten',
        'Zustandsdaten',
        'Verbindungsdaten',
        'Basisdaten',
        'Bewegungsdaten',
        'Analysedaten',
        'Betriebsdaten',
        'Standortbezogene Verkehrsdaten',
        'Standortdaten',
        'Standortbezogene Umweltdaten',
        'Kennungsdaten',
        'Identifikationsdaten',
        'Bilddaten aus Außenbildkameras',
      ],
    },
  },
  {
    explicitChannels: [],
    implicitChannels: ['EMail', 'DirectMail', 'Phone'],
    consentId: 'DEICC01PSM',
    purpose: 'IndividualCustomerCare',
    legalEntities: ['PorscheAG', 'PSMGmbH', 'PFSGmbH', 'ResponsibleImporter', 'ResponsibleDealers'],
    dataScopes: [
      'Kontaktdaten',
      'Betreuungsdaten',
      'Serviceinformationen',
      'Vertragsdaten',
      'Fahrzeugdaten',
      'Daten zu meinen Interessen',
      'Daten zu meinen Diensten',
    ],
    contentfulReference:
      'https://cdn.contentful.com/spaces/8lfo1rr5gpr0/environments/master/entries?content_type=consentWithChannel&fields.consentId=DEICC01PSM&fields.language=de_DE&fields.revision=0',
    country: 'DE',
    language: 'de_DE',
    revision: 0,
    validFrom: '2021-07-01T00:00:00.000Z',
    isAccepted: false,
    content: {
      headline: 'Einwilligung zur individuellen Kunden- und Interessentenbetreuung',
      consentTextShort:
        'Geben Sie uns Ihre Einwilligung, Sie im Rahmen der Kundenbetreuung und zu Ihren persönlichen Interessen zu kontaktieren.\n\nIch möchte im Rahmen der Kundenbetreuung und zu meinen persönlichen Interessen über diese Kanäle kontaktiert werden:',
      text: 'Ich bin damit einverstanden, dass die Porsche Sales & Marketplace GmbH, Porscheplatz 1, 70435 Stuttgart, ausgewählte Porsche Unternehmen* und deren beauftragte Dienstleister meine Kontaktdaten, Betreuungs- und Vertragsdaten (einschließlich Vertragsdaten aus Leasing- und Finanzierungsverträgen), Serviceinformationen sowie Daten zu meinen Interessen, Fahrzeugen und verwendeten Diensten zur individuellen Kunden- und Interessentenbetreuung nutzen und mich zu diesem Zweck kontaktieren.\n\nMeine Einwilligung kann ich gegenüber der Porsche Sales & Marketplace GmbH jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft zentral im My Porsche Portal im Bereich „Privatsphäre“ durch entsprechende Einstellungen widerrufen.\n\nIch möchte zur individuellen Kunden- und Interessentenbetreuung über folgende Kommunikationswege kontaktiert werden: ',
      legalParagraph:
        'Ich bin damit einverstanden, dass die Porsche Sales & Marketplace GmbH, Porscheplatz 1, 70435 Stuttgart, ausgewählte Porsche Unternehmen* und deren beauftragte Dienstleister meine Kontaktdaten, Betreuungs- und Vertragsdaten (einschließlich Vertragsdaten aus Leasing- und Finanzierungsverträgen), Serviceinformationen sowie Daten zu meinen Interessen, Fahrzeugen und verwendeten Diensten zur individuellen Kunden- und Interessentenbetreuung nutzen und mich zu diesem Zweck kontaktieren.\n\nIch möchte zur individuellen Kunden- und Interessentenbetreuung über folgende Kommunikationswege kontaktiert werden: ',
      consentTextExtended: {
        content: [],
      },
      legalParagraphExtended:
        'Die individuelle Kunden- und Interessentenbetreuung beinhaltet auf mich zugeschnittene Informationen und Angebote zu Fahrzeugen, fahrzeugbezogenen Dienstleistungen und weiteren Produkten von Porsche, Einladungen zu Veranstaltungen sowie Befragungen zu meiner Zufriedenheit und meinen Erwartungen.\n\n*Porsche Unternehmen: Dr. Ing. h.c. F. Porsche AG, Porscheplatz 1, D-70435 Stuttgart; zuständige Vertriebsgesellschaft, zuständiges Porsche Zentrum; Porsche Financial Services GmbH, Porschestraße 1, D-74321 Bietigheim-Bissingen.',
      channels: [
        {
          channel: 'DirectMail',
          translation: 'Post',
        },
        {
          channel: 'EMail',
          translation: 'E-Mail',
        },
        {
          channel: 'Phone',
          translation: 'Telefon',
        },
      ],
      consentExtendedList: [
        'Kontaktdaten',
        'Betreuungsdaten',
        'Serviceinformationen',
        'Vertragsdaten',
        'Fahrzeugdaten',
        'Daten zu meinen Interessen',
        'Daten zu meinen Diensten',
      ],
    },
  },
  {
    explicitChannels: [],
    implicitChannels: [],
    consentId: 'DEMRG01PAG',
    purpose: 'MergeVehicleCustomerData',
    legalEntities: ['PSMGmbH', 'PorscheAG'],
    dataScopes: ['Fahrzeugzustandsdaten', 'Nutzungsdaten', 'Leistungsdaten'],
    contentfulReference:
      'https://cdn.contentful.com/spaces/8lfo1rr5gpr0/environments/master/entries?content_type=consentsShort&fields.consentId=DEMRG01PAG&fields.language=de_DE&fields.revision=0',
    country: 'DE',
    language: 'de_DE',
    revision: 0,
    validFrom: '2025-09-16T11:55:33.815Z',
    isAccepted: false,
    content: {
      headline: 'Einwilligung zur Zusammenführung von Fahrzeug- und Kundendaten',
      consentTextShort:
        'Unterstützen Sie uns durch die Zusammenführung Ihrer Kunden- und Fahrzeugdaten dabei, Ihre Betreuung zu verbessern und Angebote sowie Services individuell auf Sie abzustimmen.',
      text: 'Ich bin damit einverstanden, dass zur Verbesserung der Kundenbetreuung und weiteren Individualisierung von Angeboten, Services und Produkten, Daten aus mir aktuell oder zukünftig zugeordneten Fahrzeugen durch die Dr. Ing. h.c. F. Porsche AG und die Porsche Sales & Marketplace GmbH analysiert werden. Es handelt sich um Fahrzeugzustandsdaten, Nutzungsdaten oder ähnliche Daten, die im Zusammenhang mit der Nutzung meines Fahrzeugs erhoben wurden oder zukünftig erhoben werden. \n\nDas Analyseergebnis wird in meinem individuellen Kundenprofil gespeichert und auch den mit der Dr. Ing. h.c. F. Porsche AG verbundenen Unternehmen zugänglich gemacht (eine aktuelle Aufstellung der beteiligten Gesellschaften findet sich unter https://www.porsche.com/germany/joint-customer-care).\n\nDie obenstehende Einwilligungserklärung kann ich jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. Zentraler Ansprechpartner für Einwilligung, Widerruf und Rückfragen ist die Dr. Ing. h.c. F. Porsche AG, Porscheplatz 1, 70435 Stuttgart, https://forms.porsche.com/de-de/privacy-contact/. Weitere Informationen zur Datenverarbeitung und Individualisierung finden Sie in den Datenschutzhinweisen.',
      legalParagraph:
        'Ich bin damit einverstanden, dass zur Verbesserung der Kundenbetreuung und weiteren Individualisierung von Angeboten, Services und Produkten, Daten aus mir aktuell oder zukünftig zugeordneten Fahrzeugen durch die Dr. Ing. h.c. F. Porsche AG und die Porsche Sales & Marketplace GmbH analysiert werden. Es handelt sich um Fahrzeugzustandsdaten, Nutzungsdaten oder ähnliche Daten, die im Zusammenhang mit der Nutzung meines Fahrzeugs erhoben wurden oder zukünftig erhoben werden. \n\nDas Analyseergebnis wird in meinem individuellen Kundenprofil gespeichert und auch den mit der Dr. Ing. h.c. F. Porsche AG verbundenen Unternehmen zugänglich gemacht (eine aktuelle Aufstellung der beteiligten Gesellschaften findet sich unter https://www.porsche.com/germany/joint-customer-care).\n\nDie obenstehende Einwilligungserklärung kann ich jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. Zentraler Ansprechpartner für Einwilligung, Widerruf und Rückfragen ist die Dr. Ing. h.c. F. Porsche AG, Porscheplatz 1, 70435 Stuttgart, https://forms.porsche.com/de-de/privacy-contact/. Weitere Informationen zur Datenverarbeitung und Individualisierung finden Sie in den Datenschutzhinweisen.',
      consentTextExtended: {
        content: [],
      },
      channels: [],
      consentExtendedList: ['Fahrzeugzustandsdaten', 'Nutzungsdaten', 'Leistungsdaten'],
    },
  },
  {
    explicitChannels: [],
    implicitChannels: [],
    consentId: 'DEPPN01PAG',
    purpose: 'PromotionalPushNotification',
    legalEntities: ['PSMGmbH', 'PorscheAG'],
    dataScopes: [],
    contentfulReference:
      'https://cdn.contentful.com/spaces/8lfo1rr5gpr0/environments/master/entries?content_type=consentsShort&fields.consentId=DEPPN01PAG&fields.language=de_DE&fields.revision=0',
    country: 'DE',
    language: 'de_DE',
    revision: 0,
    validFrom: '2025-09-15T00:00:00.000Z',
    isAccepted: false,
    content: {
      headline: 'Einwilligung zu Werbe-Push-Benachrichtigungen und Marketingzwecken',
      consentTextShort:
        'Erhalten Sie als Erster Informationen zu neuen Fahrzeugankündigungen, exklusiven Events und limitierten Produktangeboten.',
      text: 'Seien Sie der Erste, der über neue Fahrzeugankündigungen, exklusive Event-Erlebnisse oder limitierte Produktangebote informiert wird. \n\nSie erhalten solche Nachrichten nur, wenn Sie zuvor einer Porsche-Vertriebsgesellschaft oder einem Porsche-Händler Ihre gesonderte Einwilligung für Marketingzwecke erteilt haben.',
      legalParagraph:
        'Seien Sie der Erste, der über neue Fahrzeugankündigungen, exklusive Event-Erlebnisse oder limitierte Produktangebote informiert wird. \n\nSie erhalten solche Nachrichten nur, wenn Sie zuvor einer Porsche-Vertriebsgesellschaft oder einem Porsche-Händler Ihre gesonderte Einwilligung für Marketingzwecke erteilt haben.',
      consentTextExtended: {
        content: [],
      },
      channels: [],
      consentExtendedList: [],
    },
  },
]

// GET https://api.ppc.porsche-preview.com/user/api/v2/de/de_DE/withdrawal-info
export const widthdrawalResponse = {
  htmlText:
    'Meine obenstehenden Einwilligungen kann ich jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. An anderer Stelle erteilte Einwilligungen, z.B. in Porsche Zentren, bleiben hiervon unberührt.\n\nIhr zentraler Ansprechpartner für Einwilligung, Widerruf und Rückfragen ist die Porsche Sales & Marketplace GmbH, Porscheplatz 1, 70435 Stuttgart – eine kurze Nachricht per Post oder über das <a href="https://www.porsche.com/international/privacy/contact/" rel="noopener" target="_blank">Kontaktformular</a> genügt.\n\nWeitere Informationen zur Datenverarbeitung und Individualisierung im Bereich der Porsche Kunden- und Interessentenbetreuung finden Sie in den <a href="https://terms.porsche-preview.com/de/de-DE/privacy" rel="noopener" target="_blank">Datenschutzhinweisen</a>.',
  text: 'Meine obenstehenden Einwilligungen kann ich jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. An anderer Stelle erteilte Einwilligungen, z.B. in Porsche Zentren, bleiben hiervon unberührt.\n\nIhr zentraler Ansprechpartner für Einwilligung, Widerruf und Rückfragen ist die Porsche Sales & Marketplace GmbH, Porscheplatz 1, 70435 Stuttgart – eine kurze Nachricht per Post oder über das {{entity_0}} genügt.\n\nWeitere Informationen zur Datenverarbeitung und Individualisierung im Bereich der Porsche Kunden- und Interessentenbetreuung finden Sie in den {{entity_1}}.',
  entities: [
    {
      key: 'entity_0',
      type: 'link',
      label: 'Kontaktformular',
      value: 'https://www.porsche.com/international/privacy/contact/',
    },
    {
      key: 'entity_1',
      type: 'link',
      label: 'Datenschutzhinweisen',
      value: 'https://terms.porsche-preview.com/de/de-DE/privacy',
    },
  ],
}

// POST https://api.ppc.porsche-preview.com/user/api/v2/de/de_DE/user-consent
export const consentPayload = [
  { consentId: 'DEPPO01PAG', isAccepted: true },
  { consentId: 'DEICC01PSM', grantedChannels: ['EMail', 'DirectMail', 'Phone'], isAccepted: true },
  { consentId: 'DEMRG01PAG', isAccepted: true },
  { consentId: 'DEPPN01PAG', isAccepted: true },
]
